import React, { useState, useEffect, Fragment } from "react";
import BottomNavigation from "../../Components/BottomNavigation/BottomNavigation";
import Item from "../../Components/Item/Item";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./OrdersList.module.css";
import Modal from "../../Components/Modal/Modal";
import OrdersModal from "../../Components/OrdersModal/OrdersModal";
import Button from "../../Components/Button/Button";
import {
  getDeliveryInfoApi,
  getNewOrdersApi,
  getNewPeykRequestApi,
  logOutApi,
  setDeliveryTimeApi,
} from "../../Api/DeliveryBarest";
import LoadingComponet from "../../Components/LoadingComponet/LoadingComponet";
import { getTokens } from "../../firebase";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { useHistory } from "react-router-dom";
import PeykRequest from "./PeykRequest/PeykRequest";

const OrdersList = () => {
  const [purchased, setPurchased] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState();
  const [peykDataState, setPeykDataState] = useState([]);
  const [productData, setProductData] = useState();
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [itemId, setItemId] = useState();
  const [isTokenFound, setTokenFound] = useState(false);
  const [supplierId, setSupplierId] = useState();
  /////get all new order/////
  let history = useHistory();
  const MINUTE_MS = 30000;
  useEffect(() => {
    if (!isTokenFound) {
      getTokens(setTokenFound);
    }
    getDeliverInfo();
    getAllNewOrders();
    const interval = setInterval(() => {
      getAllNewOrders();
    }, MINUTE_MS);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTokenFound]);
  ////////////////recognize andriod phone
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
      userAgent
    )
  ) {
    if (/android/i.test(userAgent)) {
      localStorage.setItem("type", "android");
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      localStorage.setItem("type", "ios");
    }
  } else {
    localStorage.setItem("type", "desktop");
  }
  // alert(localStorage.getItem("type"))
  const logout = () => {
    let info = {
      logout: "",
    };
    logOutApi(info, (succ) => {
      console.log(succ);
    });
  };
  const getDeliverInfo = async () => {
     getDeliveryInfoApi((succ,res)=>{
      if(succ){
        if (res.status === -2) {
          localStorage.clear();
          logout();
          history.push("/login");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }else{
          localStorage.setItem('role',res.deliver.role)
        }
      }
      else{
        console.log(res)
      }
     });

      
    
  };
  const getAllNewOrders =() => {
    getNewOrdersApi((succ,res)=>{
      if(succ){
        if(res.status==="0"){
          errorToast("مشکلی پیش آمده است")
        }else{
          let sorted = [...res.orders].sort((a, b) => {
            return a.id > b.id ? 1 : -1;
          });
          setData(sorted);
        }
      }else{
        console.error(res)
      }
    });
    getNewPeykRequestApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast(res.message)
        }else{
          let sorted = [...res.requests].sort((a, b) => {
            return a.id > b.id ? 1 : -1;
          });
          setPeykDataState(sorted);
        }
      }else{
        console.error(res)
      }
    });
  };
  /////close modal order list/////
  const closeList = () => {
    setPurchased(false);
  };
  //////get product info from child ////
  const handleCallback = (childData) => {
    setProductData(childData);
  };
  /////get item & supplier id from child//////
  const handleCallbackId = (childData) => {
    setItemId(childData[0]);
    setSupplierId(childData[1]);
  };
  //////////// Post Method for send preparing time ////////////
  let changeToMin =
    parseInt(hour) === ""
      ? parseInt(minute)
      : parseInt(hour * 60) + parseInt(minute);
  const sendTimeDelivery = () => {
    let info = {
      id: itemId,
      supplier_id: supplierId[0].id,
      delivery_remaining_time: changeToMin,
    };
    setDeliveryTimeApi(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        getAllNewOrders().fadeOut();
      } else {
        errorToast(res.message);
      }
    });
    setShow(false);
  };

  let loading = null;
  if (data === undefined) {
    loading = <LoadingComponet />;
  } else {
    loading = (
      <div className={Style.pageHolder}>
        <Modal
          show={purchased}
          modalClose={() => setPurchased(false)}
          translate={50}
        >
          <OrdersModal setShow={closeList} data={productData} />
        </Modal>
        <Modal show={show} modalClose={() => setShow(false)} translate={50}>
          <div className={Style.innerModal}>
            <h1 className={Style.title}>مدت زمان تحویل</h1>
            <div className={Style.inputHolder}>
              <input
                maxLength={2}
                placeholder="دقیقه"
                className={Style.time}
                value={minute}
                onChange={(e) => setMinute(e.target.value)}
              />
              {/* <span className={Style.seprate}>:</span>
              <input
                maxLength={2}
                placeholder="ساعت"
                className={Style.time}
                value={hour}
                onChange={(e) => setHour(e.target.value)}
              /> */}
            </div>
            <div className={Style.btnHolder}>
              <Button
                ClassBtn={"confirmBtn"}
                Value={"تایید"}
                ClickHandler={sendTimeDelivery}
              />
            </div>
          </div>
        </Modal>
        <MenuTitle title="لیست سفارشات" />
        <div className={Style.itemHolder}>
          <Item
            setPurchased={setPurchased}
            btnAccept={true}
            data={data}
            time={true}
            orderlist={false}
            deliver={false}
            setShow={setShow}
            address={false}
            peykData={peykDataState}
            parentParentCallback={handleCallback}
            parentCallbackId={handleCallbackId}
          />
          {
          peykDataState?.map(item=>{
            return(
              <PeykRequest key={item.id} data={item}/>
            )
          })
        }
        </div>
        
        <BottomNavigation />
      </div>
    );
  }
  return <Fragment>{loading}</Fragment>;
};

export default OrdersList;
